'use client';

import { type RefObject, useLayoutEffect, useState } from 'react';

interface DropdownPosition {
    rightAligned: boolean;
    panelVisible: boolean;
}

// NOTE: This hook should be removed in favor of using one of the select components from the design system.
//       This behavior is already implemented in the design system.
export function useDropdownPosition(
    isOpen: boolean,
    triggerRef: RefObject<HTMLElement | null>,
    panelRef: RefObject<HTMLElement | null>,
    align: 'left' | 'right' = 'left',
): DropdownPosition {
    const [rightAligned, setRightAligned] = useState(align === 'right');
    const [panelVisible, setPanelVisible] = useState(false);

    useLayoutEffect(() => {
        if (isOpen && panelRef.current && triggerRef.current) {
            const panelWidth = panelRef.current.offsetWidth;
            const triggerLeft = triggerRef.current.offsetLeft;
            const triggerWidth = triggerRef.current.offsetWidth;
            const parentWidth = (triggerRef.current.offsetParent as HTMLElement)?.offsetWidth ?? window.innerWidth;

            const wouldClipRight = triggerLeft + panelWidth > parentWidth;
            const wouldClipLeft = triggerLeft + triggerWidth - panelWidth < 0;
            setRightAligned(align === 'right' ? !wouldClipLeft : wouldClipRight);
            setPanelVisible(true);
        } else {
            setPanelVisible(false);
            setRightAligned(align === 'right');
        }
    }, [isOpen, panelRef, triggerRef, align]);

    return { rightAligned, panelVisible };
}
